import { DATA_START_MONTH } from '@/constants/broker_metrics';
import { addDays, endOfMonth, endOfWeek, format, isValid, isWeekend, parseISO, startOfMonth, startOfWeek, subDays } from 'date-fns';

export const MAX_RANGE_DAYS = 7;
export const WEEK_DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
export const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export const MINIMUM_DATE = parseISO(`${DATA_START_MONTH}-01`);

export function parseDateKey(value?: string): Date | null {
    if (!value) {
        return null;
    }
    const parsed = parseISO(value);
    return isValid(parsed) ? parsed : null;
}

function ensureMinDate(value: Date, minimum: Date): Date {
    return value < minimum ? minimum : value;
}

export function getLatestTradingDay(date: Date, minimumDate: Date): Date {
    let result = ensureMinDate(date, minimumDate);
    while (isWeekend(result) && result > minimumDate) {
        result = subDays(result, 1);
    }
    return result;
}

function getNextTradingDay(date: Date, maxDate: Date): Date {
    let result = date;
    while (isWeekend(result) && result <= maxDate) {
        result = addDays(result, 1);
    }
    return result > maxDate ? maxDate : result;
}

export function thisWeekDateRange(now = new Date()): { start: string; end: string } {
    const latestTradingDay = getLatestTradingDay(now, MINIMUM_DATE);
    const rawStart = ensureMinDate(startOfWeek(latestTradingDay, { weekStartsOn: 1 }), MINIMUM_DATE);
    const weekStart = getNextTradingDay(rawStart, latestTradingDay);
    return {
        start: format(weekStart, 'yyyy-MM-dd'),
        end: format(latestTradingDay, 'yyyy-MM-dd'),
    };
}

export function countTradingDaysInclusive(start: Date, end: Date): number {
    if (end < start) {
        return 0;
    }
    let count = 0;
    for (let day = start; day <= end; day = addDays(day, 1)) {
        if (!isWeekend(day)) {
            count += 1;
        }
    }
    return count;
}

export function getCalendarDays(viewMonth: Date): Date[] {
    const start = startOfWeek(startOfMonth(viewMonth), { weekStartsOn: 1 });
    const end = endOfWeek(endOfMonth(viewMonth), { weekStartsOn: 1 });
    const days: Date[] = [];
    for (let day = start; day <= end; day = addDays(day, 1)) {
        days.push(day);
    }
    return days;
}
